<template>
  <template
    v-for="block in blocks"
    :key="block.id"
  >
    <article class="block">
      <app-component-loader
        :component-path="block.component_path"
        :objects="{ block }"
      />
    </article>
  </template>
</template>

<script setup>
import AppComponentLoader from '&/atoms/AppComponentLoader'

defineProps({
  blocks: { type: Array, required: true }
})
</script>

<style lang="scss" scoped>
.block {
  &:not(:first-child):not(:empty) {
    margin-top: 12px;
  }

  &:first-child:empty + .block {
    margin-top: 0;
  }
}
</style>